import { Component } from '@angular/core';
import { PlycaUiCheckboxComponent } from '../checkbox.component';

@Component({
  selector: 'plyca-ui-checkbox-demo',
  templateUrl: './checkbox-demo.component.html',
  standalone: true,
  imports: [PlycaUiCheckboxComponent]
})
export class CheckboxDemoComponent {}
